import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLayerOpaAction } from "../../redux/app/actions";
import {
  changeCatAction,
  changeSelRowAction,
  changeExVarCatAction,
  changeExVarNameAction,
  changeExVarNameOptAction,
  changeDistsAction,
  resetCellAction,
} from "../../redux/rsltPl/actions";
import { openProbAction } from "../../redux/ui/actions";
import Select from "../common/Select";
import Slider from "../common/Slider";
import Table from "../common/Table";
import ExVar from "../common/ExVar";
import Lgd, { createColorLgd, getContColor } from "../common/Lgd";

const mapStateToProps = (state) => {
  return {
    layerOpa: state.appReducer.layerOpa,
    geoDs: state.geoReducer.dataset,
    boringDs: state.boringReducer.dataset,
    region: state.modelAreaReducer.region,
    regionDs: state.paramReducer.region,
    plDs: state.plReducer.ds,
    rsltDs: state.rsltPlReducer.ds,
    cat: state.rsltPlReducer.cat,
    cellInfo: state.rsltPlReducer.cellInfo,
    selRow: state.rsltPlReducer.selRow,
    exVarCat: state.rsltPlReducer.exVarCat,
    exVarName: state.rsltPlReducer.exVarName,
    exVarNameOpt: state.rsltPlReducer.exVarNameOpt,
    dists: state.rsltPlReducer.dists,
  };
};

const catOpt = [
  { val: "geo", text: "地質" },
  { val: "prob", text: "予測確率" },
  //{val: 'dist', text: '説明変数'}/*★公開版で削除*/
];

const tData = [
  { ID: "ID", text: "平面ID", class: "tsS", abbre: null },
  { ID: "ZAttr", text: "Z属性", class: null, abbre: null },
  { ID: "ZVal", text: "Z値", class: null, abbre: null },
  { ID: "divNumX", text: "分割数(X)", class: null, abbre: null },
  { ID: "divNumY", text: "分割数(Y)", class: null, abbre: null },
];

class Main extends Component {
  constructor(props) {
    super(props);
    this.changeCat = this.changeCat.bind(this);
    this.apply = this.apply.bind(this);

    this.props.dispatch(openProbAction(false));
  }

  /*
   * 種別変更
   * @since hara 2021-02-09
   */
  changeCat(e) {
    const val = e.target.value;
    this.props.dispatch(changeCatAction(val));
  }

  /*
   * 予測結果表示
   * @since hara 2021-02-09
   */
  apply() {
    if (this.props.selRow === null) return;

    //凡例データリセット
    this.props.dispatch(resetCellAction());
    this.props.dispatch(changeDistsAction([]));

    const ds = this.props.rsltDs[this.props.selRow];

    /*
     * 種別が説明変数の場合コンター凡例作成
     */
    let lgd;
    let lgdStep = [];
    if (this.props.cat === "dist") {
      let minDist;
      let maxDist;

      Object.keys(ds.elem).forEach((key, index) => {
        const el = ds.elem[key];
        const dist = el.env[this.props.exVarCat][this.props.exVarName].dist;
        if (index === 0) {
          minDist = dist;
          maxDist = dist;
        } else {
          if (dist < minDist) minDist = dist;
          if (maxDist < dist) maxDist = dist;
        }
      });

      const revMaxDist = Math.ceil(maxDist);
      const revMinDist = Math.floor(minDist);
      const range = revMaxDist - revMinDist;
      const step = range / 10;

      let dists = [];
      for (let i = 0; i < 10; i++) {
        const min = revMaxDist - step * (i + 1);
        const max = revMaxDist - step * i;
        dists.push(min + " ~ " + max);
        lgdStep.push({ min: min, max: max });
      }
      lgd = createColorLgd(dists);
      this.props.dispatch(changeDistsAction(lgd));
    }

    /*
     * 平面コンター作成
     */
    let data = [];
    let count = 0;
    const allGeos = this.props.geoDs.flatMap((ds) => ds.geo);
    Object.keys(ds.elem).forEach((key) => {
      count++;
      const el = ds.elem[key];

      let coords = [];
      el.node.forEach((el2) => {
        const node = ds.node[el2];
        coords.push([node.lon, node.lat]);
      });
      coords.push(coords[0]); //最初の座標を最後に追加

      let color;
      switch (this.props.cat) {
        case "geo":
          //color = this.props.geoDs[ds.geoDsID - 1].geo[el.geoID - 1].color;
          color = allGeos.find((item) => item.ID == el.geoID).color;
          break;
        case "prob":
          color = getContColor(el.prob);
          break;
        case "dist":
          const dist = el.env[this.props.exVarCat][this.props.exVarName].dist;
          let index;
          for (let i = 0; i < 10; i++) {
            const maxJudge =
              i === 0 ? dist <= lgdStep[i].max : dist < lgdStep[i].max;
            if (lgdStep[i].min <= dist && maxJudge) {
              index = i;
              break;
            }
          }
          color = lgd[index].color;
          break;
      }

      data.push({
        dsID: this.props.selRow,
        elemID: key,
        color: color,
        coords: coords,
      });
    });

    window.createRsltPl(data);
    window.changeRsltPlOpa(this.props.layerOpa);

    /*
     * ボーリングカラーを地質に変更
     */
    window.delGeoBoring();

    const plDs = this.props.plDs[this.props.selRow];

    const createBoring = (data, geoIndex) => {
      const colorID = data.geo[geoIndex][1];
      if (colorID !== 0) {
        //const color = this.props.geoDs[0].geo[colorID - 1].color;//******地質データセット選択可になったら[0]の部分変更
        const color = allGeos.find((item) => item.ID == colorID).color;
        window.createGeoBoring(data.lon, data.lat, color);
      }
    };

    //選択地域の座標を取得
    const range = this.props.regionDs[this.props.region].range;

    this.props.boringDs.forEach((el) => {
      if (el.vis) {
        //表示ボーリングの場合
        el.data.forEach((el2) => {
          //選択地域内のボーリングのみ地質カラー表示
          if (
            range.x1 <= el2.lon &&
            el2.lon <= range.x2 &&
            range.y1 <= el2.lat &&
            el2.lat <= range.y2
          ) {
            //同地点に複数ボーリングが存在する場合の処理途中
            //（複数あるのはバグのもとになるので作らせないようにするのが望ましい）
            //                    const sameCoordID = window.getSameCoordID(el2.lon, el2.lat);
            //                    let drawBoring = true;
            //                    if (1 < sameCoordID.length) {//同地点に複数ボーリングが存在する場合
            //                        sameCoordID.forEach(el => {
            //                            const ID = el.split('_');
            //
            //                            if (ds[ID[0]].data[ID[1]].sel !== undefined) {//selプロパティーがある場合
            //                                ID = ID;
            //                            }
            //                        });
            //                    } else {
            //
            //                    }

            if (plDs.ZAttr === "dep") {
              //推定面のZ属性が「深度」の場合
              let preZVal = 0; //一つ前の地質のZ値

              for (let i = 0; i < el2.geo.length; i++) {
                let curZVal = el2.geo[i][0]; //現在の地質のZ値
                if (el.depThkRdo === "thk")
                  //地質のZ属性が「層厚」の場合深度を出す
                  curZVal += preZVal;

                if (preZVal < plDs.ZVal && plDs.ZVal <= curZVal) {
                  //地質のZ値が含まれる場合
                  createBoring(el2, i);
                  break;
                }

                preZVal = curZVal;
              }
            } else {
              //推定面のZ属性が「標高」の場合
              let preElv = el2.GL; //一つ前の地質の標高
              let curElv = 0; //現在の地質の標高
              let preZVal = 0; //一つ前の地質のZ値

              for (let i = 0; i < el2.geo.length; i++) {
                let orgZVal = el2.geo[i][0]; //元の地質のZ値
                let curZVal = orgZVal;
                if (el.depThkRdo === "dep")
                  //地質のZ属性が「深度」の場合層厚を出す
                  curZVal -= preZVal;

                curElv = preElv - curZVal;
                if (
                  (i === 0 && el2.GL === plDs.ZVal) || //地点標高と推定面標高が同じ場合
                  (curElv <= plDs.ZVal && plDs.ZVal < preElv)
                ) {
                  //地質のZ値が含まれる場合
                  createBoring(el2, i);
                  break;
                }

                preElv = curElv;
                preZVal = orgZVal;
              }
            }
          }
        });
      }
    });
  }

  render() {
    let lgdData = "";
    switch (this.props.cat) {
      case "geo":
        lgdData = this.props.geoDs[0].geo;
        break;
      case "dist":
        lgdData = this.props.dists;
        break;
    }

    return (
      <div>
        {this.props.rsltDs.length === 0 ? (
          <p>予測結果が存在しません。</p>
        ) : (
          <div className="l-flex">
            <div className="RsltPlWrap">
              <div className="l-row">
                <Select
                  label="種別"
                  options={catOpt}
                  value={this.props.cat}
                  class="selectM"
                  blank={false}
                  action={null}
                  change={this.changeCat}
                />
                <Slider
                  label="透過率"
                  value={this.props.layerOpa}
                  blank={true}
                  action={changeLayerOpaAction}
                />
              </div>

              {this.props.cat === "dist" && (
                <ExVar
                  exVarCat={this.props.exVarCat}
                  exVarName={this.props.exVarName}
                  exVarNameOpt={this.props.exVarNameOpt}
                  exVarCatAction={changeExVarCatAction}
                  exVarNameAction={changeExVarNameAction}
                  exVarNameOptAction={changeExVarNameOptAction}
                />
              )}
              <div>
                <Table
                  class={
                    this.props.cat === "dist"
                      ? "RsltPlTWrap--dist l-mtS"
                      : "RsltPlTWrap l-mtS"
                  }
                  tData={tData}
                  ds={this.props.plDs}
                  action={changeSelRowAction}
                />
                <div className="l-right l-mtS">
                  <button className="sBtn" onClick={this.apply}>
                    適用
                  </button>
                </div>
              </div>
            </div>
            <div className="l-mlM">
              <Lgd
                data={lgdData}
                cat={this.props.cat}
                cellInfo={this.props.cellInfo}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
